import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {Typography} from "@mui/material";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {changeOfferTypeTab} from "../../reducers/controlsReducer";


function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

export default function CollectionTabs({items, page, handleChangePage, handleChangeRowsPerPage, DataComponent}) {

    const dispatch = useDispatch();
    const {offerTypeTab} = useSelector((state) => state.controlsReducer)

    const handleTabChange = (event, newValue) => {
        dispatch(changeOfferTypeTab());
    };

    return (
        <>
            <Box sx={{bgcolor: 'background.paper', borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    defaultValue={true}
                    value={offerTypeTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="prints"
                >
                    <Tab label={'Have'} value={true}/>
                    <Tab label={'Want'} value={false}/>
                </Tabs>
            </Box>
            <TabPanel value={offerTypeTab} index={true}>
                <DataComponent items={items} page={page} handleChangePage={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} isHave={true}/>
            </TabPanel>
            <TabPanel value={offerTypeTab} index={false}>
                <DataComponent items={items} page={page} handleChangePage={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} isHave={false}/>
            </TabPanel>
        </>
    )

}
